module.exports = __webpack_public_path__ + "img/feature_buy_en.fbb2d0ef.png";